<template>
	<div class="pc100W">
			<van-swipe class="swipeHome" :autoplay="5000" lazy-render>
			  <van-swipe-item v-for="(image,index) in banners" :key="index">
				  <div style="position: relative;">
					  <van-row>
						<van-col span="24">
							<img :src="image.icon" />
							<div class="cons">
								<h2>Game on!</h2>
								<p>{{ image.title }}{{ image.desc }}</p>
								<a href="#">Read More</a>
							</div>
						</van-col>
					  </van-row>
			      </div>
			    </van-swipe-item>
			</van-swipe>
		
	</div>
	
	<div class="pc100W bgpurple">
		<div class="pcMaxW">
			<div class="title"><h2>Latest Games</h2></div>
			<div class="gameItem" v-for="(image,index) in images" :key="index">
				<div class="imgThumb"><img :src="image.icon" /></div>
				<div class="txtBox">
					<div class="tops">{{ image.subTitle }}</div>
					<h3>{{ image.title }}</h3>
					<p>{{ image.desc }}</p>
					<a href="#" class="more">Read More</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref,onMounted,getCurrentInstance } from 'vue'
	import { useI18n } from "vue-i18n"
	
	const { proxy } = getCurrentInstance();
	
	const active = ref(0);
	const total = ref(2);
	const banners = ref([
		{ icon : require('@/assets/images/hongkong_000.png'), color: 'primary',
			title: '《永夜神域》',
			subTitle: 'MMORPG', 
			desc: '世界被永恆暗夜吞噬，諸神墜落、魔族崛起。玩家將以最後的「光之繼承者」身份重返神域，奪回被腐化的聖器、重啟破碎的秩序。跨伺服萬人領地戰、神話職業覺醒、黑暗祈禱儀式等系統，帶來史詩級魔幻沉浸。' ,
		}
	])
	const images = ref([
		{ icon : require('@/assets/images/1.png'), color: 'primary',
			title: '永夜神域',
			subTitle: 'MMORPG', 
			desc: '世界被永恆暗夜吞噬，諸神墜落、魔族崛起。玩家將以最後的「光之繼承者」身份重返神域，奪回被腐化的聖器、重啟破碎的秩序。跨伺服萬人領地戰、神話職業覺醒、黑暗祈禱儀式等系統，帶來史詩級魔幻沉浸。' ,
		},
		{ icon : require('@/assets/images/2.png'), color: 'dark',
			title: '黯獄王座',
			subTitle: 'MMOARPG', 
			desc: '古老王座再次出現在裂界深處，無數勢力為了奪得支配世界的資格而展開血色爭奪。玩家可化身禁忌魔法師、墮落聖裁者等黑暗職業，進行跨國軍團攻城、王座輪替戰，決定世界最終統治者。' ,
		},
		{ icon : require('@/assets/images/3.png'), color: 'warning',
			title: '漆黑聖約',
			subTitle: 'MMORPG', 
			desc: '眾神消亡後，人類與魔族締結了被視為罪孽的「黑之契約」。你將在混亂的高魔時代中，收束失控的契約力量、重鑄崩壞秩序。無限魔紋搭配、禁術覺醒、深淵遠征將完全改寫你的命運。' ,
		}
	])
	const isLoading = ref(false)
	
	onMounted(()=>{
		
	})
</script>

<style lang="less" scoped>
	.more{
		position: relative;padding: 0 1.5rem 0 0;box-sizing: border-box;
		&::after{
			position: absolute;right: 0;top: 50%;transform: translate(0,-50%);
			content: '>';display: block;font-weight: 600;
			font-size: 0.75rem;color: #b01ba5;opacity: 0.5;
		}
		&::before{
			position: absolute;right: 0.5rem;top: 50%;transform: translate(0,-50%);
			content: '>';display: block;font-weight: 600;
			font-size: 0.75rem;color: #b01ba5;opacity: 1;
		}
	}
	.bgpurple{
		background: #0c062e;padding: 115px 0;
		.title{
			font-size: 30px;color: #fff;
			    text-transform: uppercase;
			    font-weight: 700;
			    font-style: italic;
		}
		.gameItem{
			margin-top: 86px;
			.imgThumb{
				    width: 362px;
				    float: left;
				    margin-right: 30px;
					img{
						max-width: 100%;
					}
			}
			.txtBox{
				height: 350px;background: rgba(255,255,255,0.05);
				color: #fff;padding-right: 30px;box-sizing: border-box;
				.tops{
					font-size: 18px;
					    font-weight: 500;
					    margin-bottom: 20px;padding-top: 40px;
				}
				h3{
					margin-bottom: 40px;
				}
				p{
					font-size: 15px;
					    font-weight: 500;
					    color: #68647d;
					    margin-bottom: 42px;line-height: 1.6;
				}
				a{
					font-size: 15px;
					    text-transform: uppercase;
					    font-weight: 700;
					    font-style: italic;
					    color: #fff;
				}
			}
		}
	}
	.swipeHome{
		border-bottom: 2px solid #b01ba5;
		.van-swipe-item{
			height: 921px;box-sizing: border-box;
			position: relative;
			&::before{
				content: ' ';display: block;position: absolute;left: 0;top: 0;z-index: 1;
				width: 100%;height: 100%;background: rgba(0,0,0,0.6);
			}
			&::after{
				content: ' ';display: block;position: absolute;left: 0;top: 0;z-index: 2;
				width: 100%;height: 100%;background: rgba(#821FC7, 0.24);
			}
			img{
				height: 100%;filter: grayscale(0.5);
			}
			p{
				line-height: 1.6;
			}
			.cons{
				z-index: 10;text-align: center;
				position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);
				h2{
					color: #fff;font-size: 160px;font-weight: 500;
				}
				p{
					font-size: 24px;
					color: rgba(255, 255, 255, 0.4);
					font-weight: 500;
					margin-bottom: 70px;
				}
				a{
					    display: inline-block;
					    border: none;
					    font-size: 14px;
					    font-weight: 700;
					    font-style: italic;
					    min-width: 186px;
					    padding: 24px 30px;
					    border-radius: 0;
					    text-transform: uppercase;
					    color: #081624;
					    line-height: normal;
					    cursor: pointer;
					    text-align: center;
					    background: #fff;
					    position: relative;
					    z-index: 1;
						box-sizing: border-box;
						&::before{
							position: absolute;
							    content: "";
							    width: 100%;
							    height: 100%;
								box-shadow: 0 0 9px 3px rgba(226, 30, 228, 0.24);
								    left: 0;
								    top: 0;
								    background: #fff;
								    z-index: -1;
						}
						&::after{
							position: absolute;
							    content: "";
							    width: 100%;
							    height: 100%;
							    left: 9px;
							    top: 10px;
							    background: #b01ba5;
							    z-index: -2;
							    -webkit-box-shadow: 0 0 9px 3px rgba(226, 30, 228, 0.24);
							    box-shadow: 0 0 9px 3px rgba(226, 30, 228, 0.24);
						}
				}
			}
		}
		.header-text{
			text-align: right;margin-top: 6%;
			h6{
				font-size: 20px;
				color: #fff;
				font-weight: 400;
				margin-bottom: 25px;
			}
			h4{
				font-size: 45px;
				text-transform: uppercase;
				margin-bottom: 25px;
				font-weight: 700;
			}
		}
	}
	.pages {
	    position: absolute;width: 10px;height: 60px;box-sizing: border-box;gap:15px;
	    right: 0;
	    top: 50%;
	    padding: 0;
		transform: translate(0,-50%);
		display: flex;flex-direction: column;
		a{
			display: inline-flex;width: 10px;height: 10px;
			align-items: center;justify-content: center;font-size: 0;
			border: 2px solid #e91e63;box-sizing: border-box;
			&.active{
				background: #e91e63;
			}
		}
		
	}
	.title{ 
		justify-content: center;
		margin-bottom: 40px;
		h5{
			font-size: 40px;
			text-decoration: none;
			color: #544FC3;
			text-align: center;
			font-family: 'Josefin Sans', sans-serif;
			letter-spacing: 1px;
		}
	}
	.imgItems{
		.fonts{
			font-size: 27px;color: #000;margin-bottom: 20px;
			text-align: center;
		}
		.items{
			position: relative;overflow: hidden;
			.mask{
				background-color: rgba(0, 0, 0, 0.67);
				top: -200px;
				-ms-filter: "progid: DXImageTransform.Microsoft.Alpha(Opacity=0)";
				filter: alpha(opacity=0);
				opacity: 0;
				-webkit-transition: all 0.3s ease-out 0.5s;
				-moz-transition: all 0.3s ease-out 0.5s;
				transition: all 0.3s ease-out 0.5s;
				width: 100%;padding: 6.5em 1.5em;height: 100%;box-sizing: border-box;
				position: absolute;overflow: hidden;z-index: 10;
				p{
					-webkit-transform: translateY(-200px);
					-moz-transform: translateY(-200px);
					-o-transform: translateY(-200px);
					-ms-transform: translateY(-200px);
					transform: translateY(-200px);
					-webkit-transition: all 0.2s ease-in-out 0.2s;
					-moz-transition: all 0.2s ease-in-out 0.2s;
					-o-transition: all 0.2s ease-in-out 0.2s;
					-ms-transition: all 0.2s ease-in-out 0.2s;
					transition: all 0.2s ease-in-out 0.2s;
					text-indent: 2em;
					font-size: 1em;line-height: 1.6;
					position: relative;
					color: #fff !important;
					padding: 0.5em 0;
					text-align: center;
					margin: 0;
				}
			}
			&:hover{
				.mask{
					top: 0;opacity: 1;
					p{
						-webkit-transform: translateY(0);
						-moz-transform: translateY(0);
						-o-transform: translateY(0);
						-ms-transform: translateY(0);
						transform: translateY(0);
					}
				}
			}
		}
		
		/deep/ img{
			width: 100%;vertical-align: middle;
		}
		.lh15{
			line-height: 1.5;
		}
	}
</style>